import { useState, useEffect } from 'react'
import styles from './OfflineBanner.module.css'

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine)

  useEffect(() => {
    const go = () => setOffline(false)
    const stop = () => setOffline(true)
    window.addEventListener('online', go)
    window.addEventListener('offline', stop)
    return () => {
      window.removeEventListener('online', go)
      window.removeEventListener('offline', stop)
    }
  }, [])

  if (!offline) return null

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <span className={styles.dot} aria-hidden="true" />
      You are offline — showing cached data
    </div>
  )
}
